import cx from 'clsx';
import { web2app } from '@kcd/app-interface';
import { Badge } from '@kcd/design-system';

import Skeleton from '~/components/Skeleton';
import type { OAISchema } from '~/types/openapi';
import { getCategoryImage } from '~/utils/asset';

interface Props {
  gnb: OAISchema['PlacementNavigationBarResponse'];
  onClick?: (gnb: OAISchema['PlacementNavigationBarResponse']) => void;
  className?: string;
}

function MarketCategoryItem({ gnb, onClick, className }: Props) {
  const {
    categoryUrl,
    categoryName,
    categorySrc,
    isNew,
    // FIXME - swagger 수정 후 반영
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } = gnb as any;

  const handleClick = () => {
    web2app.openModal({
      url: categoryUrl,
    });

    onClick?.(gnb);
  };

  return (
    <div
      role="presentation"
      onClick={handleClick}
      className={cx(
        'flex gap-[2px] snap-center flex-col items-center relative',
        className,
      )}
    >
      {isNew && <Badge className="absolute -top-6 right-[-10px]" type="new" />}
      <div className="flex size-48 items-center justify-center rounded-16 bg-screen-02 p-6">
        <img
          src={getCategoryImage(categorySrc)}
          alt=""
          className="size-[36px]"
        />
      </div>
      <p className="w-full text-center typo-caption100-regular">
        {categoryName}
      </p>
    </div>
  );
}

export default MarketCategoryItem;

export const CategoryItemSkeleton = () => {
  return (
    <div className="flex cursor-pointer flex-col items-center">
      <div className="relative aspect-1 w-full px-2">
        <Skeleton width="100%" height={0} style={{ height: '100%' }} />
      </div>
      <Skeleton width={60} height={12} className="mt-8" />
    </div>
  );
};
